import React from 'react'
import { Controller, useFormContext } from "react-hook-form";
import EditText from "../../../../../components/base/edit-text/edit-text";
import { LoginFormStyled } from "./login-form.styled";
import Button from "../../../../../components/base/button/button";
import i18n from '../../../../../translations/strings';

const LoginForm = (props: any) => {

  const {control, formState: { errors }, register, handleSubmit } = useFormContext();

  return (
    <LoginFormStyled.Container>
        <Controller
          control={control}
          rules={{
            required: true,
          }}
          render={({ field: { onChange, value } }) => (
            <EditText
              error={errors?.username?.message?.toString()}
              fullWidth {...register('username')}
              defaultValue={value}
              placeholder={i18n.t('common.email')}
              onChange={onChange}
              label={i18n.t('common.email')}
            />
          )}
          name='username'
        />
      <LoginFormStyled.Separator />
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            error={errors?.password?.message?.toString()}
            fullWidth {...register('password')}
            defaultValue={value}
            placeholder={i18n.t('common.password')}
            onChange={onChange}
            label={i18n.t('common.password')}
            isPassword
          />
        )}
        name='password'
      />
      <LoginFormStyled.ContainerButton>
        <Button onClick={handleSubmit(props.onSubmit, props.onError)} label={i18n.t('login.login')} disabled={props.loading}/>
      </LoginFormStyled.ContainerButton>

    </LoginFormStyled.Container>
  );
};

export default LoginForm;
